import { Phone, Mail, MapPin, Clock } from "lucide-react";
import Seo from "../components/Seo";
import { useState } from "react";

const Contact = () => {
  const [sent, setSent] = useState(false);
  const [form, setForm] = useState({ name: "", email: "", phone: "", message: "" });
  const onSubmit = (e) => { e.preventDefault(); setSent(true); };

  return (
    <div className="vd-page" data-testid="page-contact">
      <Seo title="Contact Us" description="Get in touch with ValueDrive Auto Solutions — Middlesbrough & Teesside. 24/7 roadside support, mobile fitting bookings and expert advice." path="/contact" />
      <section className="vd-section-secondary py-14">
        <div className="vd-container">
          <h1 className="mb-3">Contact Us</h1>
          <p className="vd-muted max-w-2xl">Need help? Get in touch — we respond within 1 business hour.</p>
        </div>
      </section>

      <section className="vd-container py-10 grid grid-cols-1 lg:grid-cols-[1fr_2fr] gap-10">
        <div className="space-y-6">
          <InfoRow icon={<MapPin color="var(--primary-red)" />} t="Address" v="14 Albert Road, Middlesbrough, TS1 1QA" />
          <InfoRow icon={<Phone color="var(--primary-red)" />} t="Phone (24/7)" v="07979 210250" link="tel:07979210250" />
          <InfoRow icon={<Phone color="var(--primary-red)" />} t="Phone (24/7)" v="07498 408406" link="tel:07498408406" />
          <InfoRow icon={<Mail color="var(--primary-red)" />} t="Email" v="info@valuedriveauto.co.uk" link="mailto:info@valuedriveauto.co.uk" />
          <InfoRow icon={<Clock color="var(--primary-red)" />} t="Hours" v="Mon–Sun: 24/7 callouts" />
        </div>

        <form onSubmit={onSubmit} className="vd-card p-6 space-y-3" data-testid="contact-form">
          {sent ? (
            <div className="text-center py-10" data-testid="contact-success">
              <p className="vd-heading font-semibold text-lg mb-2">Thanks for reaching out!</p>
              <p className="vd-muted">Our team will get back to you shortly.</p>
            </div>
          ) : (
            <>
              <input className="vd-input" placeholder="Full Name" required value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} data-testid="contact-name" />
              <input className="vd-input" placeholder="Email" type="email" required value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} data-testid="contact-email" />
              <input className="vd-input" placeholder="Phone" value={form.phone} onChange={(e) => setForm({ ...form, phone: e.target.value })} data-testid="contact-phone" />
              <textarea className="vd-input" placeholder="How can we help?" rows={5} required value={form.message} onChange={(e) => setForm({ ...form, message: e.target.value })} data-testid="contact-message" />
              <button type="submit" className="vd-btn-primary w-full" data-testid="contact-submit">Send Message</button>
            </>
          )}
        </form>
      </section>
    </div>
  );
};

const InfoRow = ({ icon, t, v, link }) => (
  <div className="flex items-start gap-4">
    <div className="p-3 rounded-md" style={{ background: "var(--bg-secondary)" }}>{icon}</div>
    <div>
      <p className="vd-muted text-xs uppercase tracking-wider">{t}</p>
      {link ? <a href={link} className="vd-heading font-medium hover:text-[var(--primary-red)]">{v}</a> : <p className="vd-heading font-medium">{v}</p>}
    </div>
  </div>
);

export default Contact;
